<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7);  " class="pi pi-th-large"></i>
        <h1>הוספת סוג נוכחות</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label >שם מזהה</label>

          <InputText type="text" v-model="newItem.id" autofocus />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="lastname6">שם</label>
          <InputText id="lastname6" type="text" v-model="newItem.hebrewName" />
        </div>
      </div>

      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../service/Service";
const { v4: uuidv4 } = require("uuid");
export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {

    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
      newItem: null,
    };
  },

  methods: {
    setNewItwmFields() {
      this.newItem = {
        id: null,
        hebrewName: null,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
          validate = false;
        }
      }

      if (validate === true) {
        // this.newItem.id = uuidv4();
        await this.service
          .post(this.newItem,'presence-status')
          .then((data) => {
            this.$emit("addItem", this.newItem);
            this.setNewItwmFields();
            this.openNotification(
              "top-right",
              "success",
              `<i class='bx bx-select-multiple`,
              `מעולה`,
              `המידע התתוספה במערכת`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר משתמש עם ת.ז. זהה`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>